import { useState } from 'react';
import './VideoSection.scss';

const VideoSection = () => {
  const [loadedVideos, setLoadedVideos] = useState({});

  const videos = [
    {
      id: 6,
      title: 'PDF를 HWP로 변환',
      videoId: 'l096gCusddY',
      isFree: false,
      isPro: true
    },
    {
      id: 7,
      title: '나만의 문제은행 구축',
      videoId: 'sCCwrkYR_fs',
      isFree: false,
      isBank: true
    },
    {
      id: 2,
      title: '수학 문제 풀이 AI',
      videoId: '7XbkG6eLJ2g',
      isFree: true
    },
    {
      id: 3,
      title: '수학 문제 변형 AI',
      videoId: 'kd3Hfs9LSBg',
      isFree: true
    },
    {
      id: 4,
      title: '수학 도형 그리기 AI',
      videoId: 'KX5iIhxSN_w',
      isFree: true
    },
    {
      id: 5,
      title: '수학 도형 전용 그림판',
      videoId: 'ChVMaxyzlVQ',
      isFree: true
    }
  ];

  const handleLoadVideo = (videoId) => {
    setLoadedVideos((prev) => ({
      ...prev,
      [videoId]: true
    }));
  };

  return (
    <section id="video" className="video-section section">
      <div className="container">
        <header className="header">
          <h2 className="title">
            <span className="title-accent">실제 동작</span> 시연 영상
          </h2>
          <p className="subtitle">직접 확인하는 생생한 사용 경험</p>
        </header>

        <div className="video-grid">
          {videos.map((video) => (
            <div key={video.id} className="video-item">
              <h3 className="video-title">
                {video.title}
                {video.isFree && <span className="free-badge">무료</span>}
                {video.isPro && <span className="pro-badge">PRO</span>}
                {video.isBank && <span className="bank-badge">문제은행</span>}
              </h3>
              <div className="video-wrapper">
                <div className="video-container">
                  <div className="video-frame">
                    {loadedVideos[video.videoId] ? (
                      <iframe
                        src={`https://www.youtube-nocookie.com/embed/${video.videoId}?autoplay=1&rel=0`}
                        title={video.title}
                        frameBorder="0"
                        loading="lazy"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      />
                    ) : (
                      <button
                        type="button"
                        className="video-preview"
                        onClick={() => handleLoadVideo(video.videoId)}
                        aria-label={`${video.title} 영상 재생`}
                        style={{
                          backgroundImage: `linear-gradient(180deg, rgba(8, 15, 28, 0.1), rgba(8, 15, 28, 0.82)), url(https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg)`
                        }}
                      >
                        <span className="video-preview-play" aria-hidden="true">
                          <span className="video-preview-play-icon" />
                        </span>
                        <span className="video-preview-text">클릭해서 영상 재생</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoSection;

